import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-1" };
const _hoisted_3 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_4 = {
    key: 0,
    class: "rounded-lg border border-ewhite-200 bg-white p-4 text-sm text-eblack-600"
};
const _hoisted_5 = {
    key: 1,
    class: "grid gap-5 rounded-lg border border-ewhite-200 bg-white p-4 shadow-sm xl:grid-cols-[1fr_320px]"
};
const _hoisted_6 = { class: "flex flex-col gap-2" };
const _hoisted_7 = { class: "text-sm font-medium text-eblack-700" };
const _hoisted_8 = {
    key: 0,
    class: "rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-700"
};
const _hoisted_9 = { class: "relative" };
const _hoisted_10 = ["placeholder", "disabled"];
const _hoisted_11 = {
    key: 0,
    class: "absolute right-3 top-1/2 -translate-y-1/2 text-xs text-eblack-400"
};
const _hoisted_12 = {
    key: 1,
    "data-test": "font-dropdown",
    class: "max-h-48 overflow-y-auto rounded-lg border border-ewhite-300 bg-white shadow-sm"
};
const _hoisted_13 = ["data-test", "onMousedown"];
const _hoisted_14 = { class: "text-xs text-eblack-400" };
const _hoisted_15 = {
    key: 2,
    class: "flex items-center gap-2 text-sm text-eblack-600"
};
const _hoisted_16 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_17 = { class: "flex items-center gap-3" };
const _hoisted_18 = ["onUpdate:modelValue", "data-test"];
const _hoisted_19 = ["onUpdate:modelValue", "data-test"];
const _hoisted_20 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_21 = { class: "flex flex-col gap-2 text-sm font-medium text-eblack-700" };
const _hoisted_22 = { class: "flex flex-col gap-2 text-sm font-medium text-eblack-700" };
const _hoisted_23 = { class: "rounded-lg border border-ewhite-200 p-4" };
const _hoisted_24 = { class: "flex flex-col gap-1" };
const _hoisted_25 = { class: "text-sm font-semibold text-eblack-800" };
const _hoisted_26 = { class: "text-sm text-eblack-500" };
const _hoisted_27 = { class: "mt-4 grid gap-4 md:grid-cols-[140px_1fr]" };
const _hoisted_28 = { class: "flex h-32 w-32 items-center justify-center rounded-lg border border-dashed border-ewhite-300 bg-ewhite-50 p-3" };
const _hoisted_29 = ["src", "alt"];
const _hoisted_30 = {
    key: 1,
    class: "text-center text-xs text-eblack-400"
};
const _hoisted_31 = { class: "flex min-w-0 flex-col gap-3" };
const _hoisted_32 = {
    key: 1,
    "data-test": "brand-theme-logo-pending",
    class: "rounded-lg bg-egreen-50 px-3 py-2 text-sm text-egreen-700"
};
const _hoisted_33 = {
    key: 2,
    "data-test": "brand-theme-logo-error",
    class: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700"
};
const _hoisted_34 = {
    key: 0,
    class: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600"
};
const _hoisted_35 = { class: "flex flex-wrap gap-2" };
const _hoisted_36 = ["disabled"];
const _hoisted_37 = ["disabled"];
const _hoisted_38 = ["disabled"];
const _hoisted_39 = { class: "rounded-lg border border-ewhite-200 bg-ewhite-50 p-4" };
const _hoisted_40 = { class: "flex gap-1 rounded-lg bg-ewhite-100 p-1" };
const _hoisted_41 = { class: "space-y-3 p-4" };
const _hoisted_42 = { class: "flex gap-2" };
const _hoisted_43 = { class: "text-xs text-eblack-400" };
const _hoisted_44 = {
    key: 2,
    class: "text-sm text-eblack-500"
};
import { computed, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import BrandEmailPreview from "./BrandEmailPreview.vue";
import FileUploadDropzone from "@/components/ui/FileUploadDropzone.vue";
import UploadProgress from "@/components/ui/UploadProgress.vue";
import { IconDeviceFloppy, IconDownload, IconRefresh } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { useAuthStore } from "@/domains/auth";
import { useOrganizations } from "@/domains/organization";
import { defaultOrganizationBrandTheme, normalizeOrganizationBrandTheme, organizationBrandThemeColorFields, organizationBrandThemeSchema, toItineraryPdfTheme, } from "@/domains/organization";
import { downloadItineraryPdf } from "@/pdf";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrandThemeIndex',
    setup(__props) {
        const toast = useToast();
        const { t } = useI18n();
        const authStore = useAuthStore();
        const { fonts, isLoading, isSaving, isLoadingFonts, fontsError, loadBrandTheme, updateBrandTheme, loadFonts, } = useOrganizations({ autoLoad: false });
        const form = reactive(cloneTheme(defaultOrganizationBrandTheme));
        const activePreview = ref("pdf");
        const formError = ref(null);
        const fontSearch = ref("");
        const showFontDropdown = ref(false);
        const logoChanged = ref(false);
        const logoError = ref(null);
        const logoUploadStatus = ref(null);
        const pendingLogoName = ref(null);
        const orgId = computed(() => authStore.currentOrgId ? Number(authStore.currentOrgId) : null);
        const brandThemeRequestContext = computed(() => ({
            orgContext: authStore.isSuperAdmin
                ? "global"
                : "tenant",
        }));
        const organizationName = computed(() => authStore.currentOrgName ||
            (orgId.value
                ? String(orgId.value)
                : t("settings.brand_theme.fallback_org_name")));
        const filteredFonts = computed(() => {
            const q = fontSearch.value.trim().toLowerCase();
            if (!q)
                return fonts.value.slice(0, 50);
            return fonts.value
                .filter((f) => f.family.toLowerCase().includes(q))
                .slice(0, 50);
        });
        const logoPreviewUrl = computed(() => form.assets.logoUrl || form.assets.publicLogoUrl || null);
        const canRemoveLogo = computed(() => Boolean(form.assets.logoStorageId || form.assets.publicLogoUrl || form.assets.logoUrl));
        function selectFont(family) {
            form.fontFamily = family;
            fontSearch.value = "";
            showFontDropdown.value = false;
        }
        function onFontSearchBlur() {
            setTimeout(() => {
                showFontDropdown.value = false;
            }, 150);
        }
        async function load() {
            if (!orgId.value)
                return;
            const theme = await loadBrandTheme(orgId.value, brandThemeRequestContext.value);
            assignTheme(theme);
            loadFonts();
        }
        async function save() {
            if (!orgId.value)
                return;
            const parsed = organizationBrandThemeSchema.safeParse(themePayload());
            if (!parsed.success) {
                formError.value =
                    parsed.error.issues[0]?.message ??
                        t("settings.brand_theme.validation.review_values");
                return;
            }
            formError.value = null;
            const theme = await updateBrandTheme(orgId.value, buildSavePayload(parsed.data), brandThemeRequestContext.value);
            assignTheme(theme);
            toast.success(t("settings.brand_theme.save_success"));
        }
        function buildSavePayload(theme) {
            return {
                fontFamily: theme.fontFamily,
                colors: theme.colors,
                support: theme.support,
                ...(logoChanged.value
                    ? { assets: { logoStorageId: theme.assets.logoStorageId } }
                    : {}),
            };
        }
        async function restoreDefaults() {
            if (!orgId.value)
                return;
            formError.value = null;
            assignTheme(defaultOrganizationBrandTheme);
            const theme = await updateBrandTheme(orgId.value, {
                fontFamily: defaultOrganizationBrandTheme.fontFamily,
                colors: defaultOrganizationBrandTheme.colors,
                support: defaultOrganizationBrandTheme.support,
                assets: {
                    publicLogoUrl: defaultOrganizationBrandTheme.assets.publicLogoUrl,
                    logoStorageId: defaultOrganizationBrandTheme.assets.logoStorageId,
                },
            }, brandThemeRequestContext.value);
            assignTheme(theme);
            toast.success(t("settings.brand_theme.restore_success"));
        }
        async function downloadSample() {
            const parsed = organizationBrandThemeSchema.safeParse(themePayload());
            if (!parsed.success) {
                formError.value =
                    parsed.error.issues[0]?.message ??
                        t("settings.brand_theme.validation.review_values");
                return;
            }
            formError.value = null;
            await downloadItineraryPdf(createSampleProjection(parsed.data));
        }
        function createSampleProjection(theme) {
            const name = organizationName.value;
            return {
                brand: {
                    name,
                    documentTitle: t("settings.brand_theme.sample.document_title"),
                    creator: name,
                    producer: name,
                    logoUrl: theme.assets.logoUrl || theme.assets.publicLogoUrl,
                },
                concierge: {
                    id: orgId.value ?? 0,
                    name,
                    company_name: name,
                    assigned_person: name,
                    email: null,
                    contact_phone: null,
                    image_url: null,
                },
                theme: toItineraryPdfTheme(theme),
                itinerary: {
                    id: 0,
                    code: t("settings.brand_theme.sample.itinerary_code"),
                    state: "APPROVED",
                    created_at: new Date().toISOString(),
                    customer: {
                        id: 0,
                        name: t("settings.brand_theme.sample.customer_name"),
                        last_name: t("settings.brand_theme.sample.customer_last_name"),
                        dni: "000000000",
                        email: "cliente@example.com",
                        country: "CR",
                        whatsapp_phone: "+50688880000",
                    },
                    slots_itineraries: [
                        {
                            id: 1,
                            quantity_of_participants: 2,
                            tax_rate: 0.13,
                            customer_subtotal: 100,
                            tax_amount: 13,
                            total_amount: 113,
                            service_slot: {
                                id: 1,
                                start_date: "2026-06-01T10:00:00.000Z",
                                end_date: "2026-06-01T12:00:00.000Z",
                            },
                            service: {
                                id: 1,
                                name: t("settings.brand_theme.sample.service_name"),
                                description: t("settings.brand_theme.sample.service_description"),
                                duration: 120,
                                additional_information: t("settings.brand_theme.sample.provider_information"),
                                provider: {
                                    id: 1,
                                    name: t("settings.brand_theme.sample.provider_name"),
                                },
                                service_type: {
                                    id: 1,
                                    name: t("settings.brand_theme.sample.service_type_name"),
                                    slug: t("settings.brand_theme.sample.service_type_slug"),
                                    custom_fields_schema: [
                                        {
                                            key: "pickup",
                                            label: t("settings.brand_theme.sample.pickup_label"),
                                        },
                                    ],
                                },
                                photos: [],
                            },
                            custom_field_values: {
                                pickup: t("settings.brand_theme.sample.pickup_value"),
                            },
                            notes: t("settings.brand_theme.sample.notes"),
                            additional_information_snapshot: t("settings.brand_theme.sample.provider_notes"),
                        },
                    ],
                    itinerary_tour: [],
                },
            };
        }
        function assignTheme(value) {
            const normalized = normalizeOrganizationBrandTheme(value);
            form.fontFamily = normalized.fontFamily;
            Object.assign(form.colors, normalized.colors);
            Object.assign(form.support, normalized.support);
            Object.assign(form.assets, normalized.assets);
            logoChanged.value = false;
            pendingLogoName.value = null;
            logoUploadStatus.value = null;
            logoError.value = null;
        }
        function cloneTheme(value) {
            return {
                fontFamily: value.fontFamily,
                colors: { ...value.colors },
                support: { ...value.support },
                assets: { ...value.assets },
            };
        }
        function onLogoUploadStart() {
            logoError.value = null;
            logoUploadStatus.value = null;
            pendingLogoName.value = null;
        }
        function onLogoUploadProgress(_file, progress) {
            logoUploadStatus.value = progress;
        }
        function onLogoUploadComplete(results) {
            const uploaded = results?.successful?.[0];
            const storageId = Number(uploaded?.storageId);
            if (!Number.isInteger(storageId) || storageId <= 0) {
                logoUploadStatus.value = null;
                return;
            }
            form.assets.logoStorageId = storageId;
            form.assets.logoUrl = null;
            form.assets.publicLogoUrl = null;
            logoChanged.value = true;
            logoUploadStatus.value = null;
            pendingLogoName.value = uploaded?.originalName ?? uploaded?.name ?? "logo";
            toast.success(t("settings.brand_theme.assets.logo_uploaded"));
        }
        function onLogoUploadError(_file, error) {
            logoUploadStatus.value = null;
            pendingLogoName.value = null;
            logoError.value = t("settings.brand_theme.assets.logo_upload_error", {
                message: error.message,
            });
        }
        function removeLogo() {
            form.assets.logoStorageId = null;
            form.assets.logoUrl = null;
            form.assets.publicLogoUrl = null;
            logoChanged.value = true;
            pendingLogoName.value = null;
            logoError.value = null;
        }
        function themePayload() {
            return {
                fontFamily: form.fontFamily,
                colors: { ...form.colors },
                support: {
                    name: nullableText(form.support.name),
                    email: nullableText(form.support.email),
                },
                assets: {
                    publicLogoUrl: nullableText(form.assets.publicLogoUrl),
                    logoStorageId: form.assets.logoStorageId,
                    logoUrl: nullableText(form.assets.logoUrl),
                },
            };
        }
        function nullableText(value) {
            const trimmed = String(value ?? "").trim();
            return trimmed ? trimmed : null;
        }
        onMounted(load);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("settings.brand_theme.title")), 1)
                ]),
                (!orgId.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)("settings.brand_theme.select_org")), 1))
                    : (_openBlock(), _createElementBlock("section", _hoisted_5, [
                        _createElementVNode("form", {
                            "data-test": "brand-theme-form",
                            class: "flex flex-col gap-4",
                            onSubmit: _withModifiers(save, ["prevent"])
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("settings.brand_theme.font_family")), 1),
                                (_unref(fontsError))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)("settings.brand_theme.fonts_load_error")), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((fontSearch).value = $event)),
                                        "data-test": "font-search",
                                        type: "text",
                                        placeholder: _unref(t)('settings.brand_theme.font_search_placeholder'),
                                        class: "w-full rounded-lg border border-ewhite-300 px-3 py-2 text-sm outline-none focus:border-egreen-500",
                                        disabled: _unref(isLoadingFonts),
                                        onFocus: _cache[1] || (_cache[1] = ($event) => (showFontDropdown.value = true)),
                                        onBlur: onFontSearchBlur
                                    }, null, 40, _hoisted_10), [
                                        [_vModelText, fontSearch.value]
                                    ]),
                                    (_unref(isLoadingFonts))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)("settings.brand_theme.loading_short")), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                (showFontDropdown.value && filteredFonts.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFonts.value, (font) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: font.family,
                                                type: "button",
                                                class: _normalizeClass(["flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-ewhite-50",
                                                    font.family === form.fontFamily
                                                        ? 'bg-ewhite-100 font-medium'
                                                        : ''
                                                ]),
                                                "data-test": `font-option-${font.family}`,
                                                onMousedown: _withModifiers(($event) => (selectFont(font.family)), ["prevent"])
                                            }, [
                                                _createElementVNode("span", {
                                                    style: _normalizeStyle({ fontFamily: font.family })
                                                }, _toDisplayString(font.family), 5),
                                                _createElementVNode("span", _hoisted_14, _toDisplayString(font.category), 1)
                                            ], 42, _hoisted_13));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (form.fontFamily)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)("settings.brand_theme.selected_font")), 1),
                                        _createElementVNode("span", {
                                            "data-test": "selected-font",
                                            class: "rounded bg-ewhite-100 px-2 py-0.5 font-medium",
                                            style: _normalizeStyle({ fontFamily: form.fontFamily })
                                        }, _toDisplayString(form.fontFamily), 5)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizationBrandThemeColorFields), (field) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                        key: field.key,
                                        class: "flex flex-col gap-2 text-sm font-medium text-eblack-700"
                                    }, [
                                        _createTextVNode(_toDisplayString(_unref(t)(field.labelKey)) + " ", 1),
                                        _createElementVNode("div", _hoisted_17, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event) => ((form.colors[field.key]) = $event),
                                                "data-test": `brand-theme-${field.key}`,
                                                type: "color",
                                                class: "h-10 w-12 cursor-pointer rounded-lg border border-ewhite-300 bg-white p-1"
                                            }, null, 8, _hoisted_18), [
                                                [_vModelText, form.colors[field.key]]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event) => ((form.colors[field.key]) = $event),
                                                "data-test": `brand-theme-${field.key}-hex`,
                                                type: "text",
                                                class: "min-w-0 flex-1 rounded-lg border border-ewhite-300 px-3 py-2 font-mono text-sm font-normal outline-none focus:border-egreen-500"
                                            }, null, 8, _hoisted_19), [
                                                [
                                                    _vModelText,
                                                    form.colors[field.key],
                                                    void 0,
                                                    { trim: true }
                                                ]
                                            ])
                                        ])
                                    ]));
                                }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("label", _hoisted_21, [
                                    _createTextVNode(_toDisplayString(_unref(t)("settings.brand_theme.support.name")) + " ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.support.name) = $event)),
                                        "data-test": "brand-theme-support-name",
                                        type: "text",
                                        class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            form.support.name,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ])
                                ]),
                                _createElementVNode("label", _hoisted_22, [
                                    _createTextVNode(_toDisplayString(_unref(t)("settings.brand_theme.support.email")) + " ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.support.email) = $event)),
                                        "data-test": "brand-theme-support-email",
                                        type: "email",
                                        class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            form.support.email,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ])
                                ])
                            ]),
                            _createElementVNode("section", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("h2", _hoisted_25, _toDisplayString(_unref(t)("settings.brand_theme.assets.company_logo")), 1),
                                    _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)("settings.brand_theme.assets.company_logo_help")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        (logoPreviewUrl.value)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: logoPreviewUrl.value,
                                                alt: _unref(t)('settings.brand_theme.assets.company_logo'),
                                                class: "max-h-full max-w-full rounded object-contain"
                                            }, null, 8, _hoisted_29))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(t)("settings.brand_theme.assets.no_logo")), 1))
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createVNode(FileUploadDropzone, {
                                            folder: "logos",
                                            "org-context": "tenant",
                                            multiple: false,
                                            "max-files": 1,
                                            "max-file-size": 2 * 1024 * 1024,
                                            "allowed-types": ['image/jpeg', 'image/jpg', 'image/png'],
                                            "auto-upload": true,
                                            disabled: _unref(isSaving),
                                            "data-test": "brand-theme-logo-upload",
                                            onUploadStart: onLogoUploadStart,
                                            onUploadProgress: onLogoUploadProgress,
                                            onUploadComplete: onLogoUploadComplete,
                                            onUploadError: onLogoUploadError
                                        }, null, 8, ["disabled"]),
                                        (logoUploadStatus.value)
                                            ? (_openBlock(), _createBlock(UploadProgress, {
                                                key: 0,
                                                state: logoUploadStatus.value.state,
                                                progress: logoUploadStatus.value.progress,
                                                message: logoUploadStatus.value.message,
                                                error: logoUploadStatus.value.error?.message,
                                                "show-progress": true,
                                                "allow-retry": false
                                            }, null, 8, ["state", "progress", "message", "error"]))
                                            : _createCommentVNode("", true),
                                        (pendingLogoName.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_unref(t)("settings.brand_theme.assets.logo_ready", { name: pendingLogoName.value })), 1))
                                            : _createCommentVNode("", true),
                                        (logoError.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(logoError.value), 1))
                                            : _createCommentVNode("", true),
                                        (canRemoveLogo.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 3,
                                                type: "button",
                                                "data-test": "remove-brand-theme-logo",
                                                class: "self-start rounded-lg border border-red-200 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-50",
                                                onClick: removeLogo
                                            }, _toDisplayString(_unref(t)("settings.brand_theme.assets.remove_logo")), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            (formError.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(formError.value), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("button", {
                                    type: "submit",
                                    "data-test": "save-brand-theme",
                                    class: "inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-egreen-500 px-4 text-sm font-medium text-white disabled:opacity-60",
                                    disabled: _unref(isSaving)
                                }, [
                                    _createVNode(_unref(IconDeviceFloppy), { class: "h-4 w-4" }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("settings.brand_theme.save")), 1)
                                ], 8, _hoisted_36),
                                _createElementVNode("button", {
                                    type: "button",
                                    "data-test": "reset-brand-theme",
                                    class: "inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-ewhite-300 px-4 text-sm text-eblack-700 disabled:opacity-60",
                                    disabled: _unref(isSaving),
                                    onClick: restoreDefaults
                                }, [
                                    _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("settings.brand_theme.restore_defaults")), 1)
                                ], 8, _hoisted_37),
                                _createElementVNode("button", {
                                    type: "button",
                                    "data-test": "sample-brand-theme",
                                    class: "inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-ewhite-300 px-4 text-sm text-eblack-700 disabled:opacity-60",
                                    disabled: _unref(isSaving),
                                    onClick: downloadSample
                                }, [
                                    _createVNode(_unref(IconDownload), { class: "h-4 w-4" }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("settings.brand_theme.download_sample")), 1)
                                ], 8, _hoisted_38)
                            ])
                        ], 32),
                        _createElementVNode("aside", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["flex-1 rounded py-1 text-xs font-medium transition-colors",
                                        activePreview.value === 'pdf'
                                            ? 'bg-white text-eblack-700 shadow-sm'
                                            : 'text-eblack-500'
                                    ]),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (activePreview.value = 'pdf'))
                                }, _toDisplayString(_unref(t)("settings.brand_theme.preview_pdf")), 3),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["flex-1 rounded py-1 text-xs font-medium transition-colors",
                                        activePreview.value === 'email'
                                            ? 'bg-white text-eblack-700 shadow-sm'
                                            : 'text-eblack-500'
                                    ]),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (activePreview.value = 'email'))
                                }, _toDisplayString(_unref(t)("settings.brand_theme.preview_email")), 3)
                            ]),
                            (activePreview.value === 'pdf')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "mt-4 overflow-hidden rounded-lg border border-ewhite-200 bg-white",
                                    style: _normalizeStyle({ fontFamily: form.fontFamily })
                                }, [
                                    _createElementVNode("div", {
                                        class: "h-16",
                                        style: _normalizeStyle({ backgroundColor: form.colors.text })
                                    }, [
                                        _createElementVNode("div", {
                                            class: "h-1",
                                            style: _normalizeStyle({ backgroundColor: form.colors.primary })
                                        }, null, 4)
                                    ], 4),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", {
                                            class: "h-3 w-2/3 rounded",
                                            style: _normalizeStyle({ backgroundColor: form.colors.text })
                                        }, null, 4),
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "h-2 w-full rounded bg-ewhite-200" }, null, -1)),
                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h-2 w-4/5 rounded bg-ewhite-200" }, null, -1)),
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("span", {
                                                class: "h-6 w-16 rounded",
                                                style: _normalizeStyle({ backgroundColor: form.colors.accent })
                                            }, null, 4),
                                            _createElementVNode("span", {
                                                class: "h-6 w-16 rounded",
                                                style: _normalizeStyle({ backgroundColor: form.colors.success })
                                            }, null, 4)
                                        ]),
                                        _createElementVNode("p", _hoisted_43, [
                                            _createTextVNode(_toDisplayString(_unref(t)("settings.brand_theme.font_label")) + " ", 1),
                                            _createElementVNode("span", {
                                                style: _normalizeStyle({ fontFamily: form.fontFamily })
                                            }, _toDisplayString(form.fontFamily), 5)
                                        ])
                                    ])
                                ], 4))
                                : (_openBlock(), _createBlock(BrandEmailPreview, {
                                    key: 1,
                                    colors: form.colors,
                                    "font-family": form.fontFamily
                                }, null, 8, ["colors", "font-family"]))
                        ])
                    ])),
                (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_unref(t)("settings.brand_theme.loading")), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
